import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const UserAccessTable = ({ users, totalCount, loading, lazyParams, onPage, onSort, onSearch, onReset, onEdit }) => {
    const { th } = useLanguage();
    const [search, setSearch] = useState({ firstName: '', lastName: '', email: '', dealerName: '' });

    const change = (field, value) => setSearch((prev) => ({ ...prev, [field]: value }));
    const submit = (e) => {
        e.preventDefault();
        onSearch(search);
    };
    const reset = () => {
        setSearch({ firstName: '', lastName: '', email: '', dealerName: '' });
        onReset();
    };

    const header = (
        <form className="grid formgrid p-fluid align-items-end" onSubmit={submit}>
            {['firstName', 'lastName', 'email', 'dealerName'].map((field) => (
                <div className="field col-12 md:col-3 lg:col-2 mb-2" key={field}>
                    <InputText value={search[field]} onChange={(e) => change(field, e.target.value)} placeholder={th(`authorizationV2.user.${field === 'dealerName' ? 'dealer' : field}`)} />
                </div>
            ))}
            <div className="col-12 lg:col-4 flex gap-2 mb-2">
                <Button type="submit" icon="pi pi-search" label={th('common.search')} className="w-auto" />
                <Button type="button" icon="pi pi-filter-slash" label={th('authorizationV2.user.clearFilters')} outlined className="w-auto" onClick={reset} />
            </div>
        </form>
    );

    const statusBody = (row) => <span className={`p-badge p-badge-${row.isActive === 1 ? 'success' : 'danger'}`}>{row.isActive === 1 ? th('authorizationV2.user.active') : th('authorizationV2.user.inactive')}</span>;

    const actionBody = (row) => <Button type="button" icon="pi pi-key" rounded text tooltip={th('authorizationV2.user.editRoles')} tooltipOptions={{ position: 'left' }} onClick={() => onEdit(row)} disabled={!row.userId} />;

    return (
        <DataTable
            value={users}
            lazy
            dataKey="id"
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            totalRecords={totalCount}
            onPage={onPage}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            loading={loading}
            rowsPerPageOptions={[10, 25, 50]}
            header={header}
            emptyMessage={th('authorizationV2.user.empty')}
            size="small"
            stripedRows
        >
            <Column field="firstName" header={th('authorizationV2.user.firstName')} sortable />
            <Column field="lastName" header={th('authorizationV2.user.lastName')} sortable />
            <Column field="email" header={th('authorizationV2.user.email')} sortable />
            <Column field="dealerName" header={th('authorizationV2.user.dealer')} sortable />
            <Column field="isActive" header={th('authorizationV2.user.status')} body={statusBody} style={{ width: '8rem' }} />
            <Column body={actionBody} style={{ width: '4rem' }} />
        </DataTable>
    );
};

export default UserAccessTable;
